'use strict';

import Splide from '@splidejs/splide';

export default () => {

    const getSlideByWrapper = (slider, sliders) => {
        const sliderID = slider.id;
        const splide = sliders.find(slider => slider.root.id === sliderID);

        return splide;
    }
    
    const triggerArrowsByTabs = (tabs, sliders) => {
        if (!tabs.length) {
            return false;
        }

        const getSliderWrapper = (wrapper, targetId) => {
            const sliderWrapper = wrapper.querySelector(targetId);

            if (!sliderWrapper) {
                return;
            }

            return sliderWrapper.querySelector('.splide')
        }
    
        const carouseTabHandler = (e, wrapper) => {
            if (!e.target.classList.contains('nav-underline-link')) {
                return;
            }

            const targetId = e.target?.dataset.bsTarget;
            const slider = getSliderWrapper(wrapper, targetId);

            if (!slider) {
                return;
            }

            const splide = getSlideByWrapper(slider, sliders);

            if (!splide) {
                return;
            }

            slidesWidthRecalculate(splide);
        }

        const handlerAllCarousels = (carouselTab) => {
            const wrapper = carouselTab.closest('.carousel-posttype')
            carouselTab.addEventListener('click', (e) => carouseTabHandler.apply(this, [e, wrapper]));
        }

        tabs.forEach(carouselTab => handlerAllCarousels.apply(this, [carouselTab]));
        return true;
    }

    const getSliderType = (slider) => {
        return slider.querySelector('.nav-pills') ? 'tabsSlider' : 'basicSlider';
    }

    const arrowHandler = (e, wrapper, sliders) => {
        const { target } = e;
        if (!target.closest('.carousel-posttype__arrow')) {
            return;
        }

        if (sliders.length === 0) {
            return;
        }

        const carouselWrapper = wrapper.closest('.carousel-posttype');
        const type = getSliderType(carouselWrapper);

        const slider = carouselWrapper?.querySelector('.splide');

        let splide = sliders.find(item => item.root.id === slider.id);

        if (type === 'tabsSlider') {
            const activeButton = wrapper.closest('.carousel-posttype__header')?.querySelector('.nav-underline-link.active');

            if (!activeButton) {
                return;
            }

            const activeTab = document.querySelector(activeButton.dataset.bsTarget);

            if (!activeTab) {
                return;
            }

            const slider = activeTab.querySelector('.splide');

            if (!slider) {
                return;
            }

            splide = getSlideByWrapper(slider, sliders);

            if (!splide) {
                return;
            }
        }

        const {classList: targetClass} = e.target.closest('.carousel-posttype__arrow')
        const isPrevClicked = targetClass.contains('carousel-posttype__arrow--prev');
        const hasFeatured = splide.root.querySelector('.post-featured');

        if (!isPrevClicked && (splide.index + splide.options.perPage + (hasFeatured ? 1 : 0) ) === splide.length) {
            return;
        }

        isPrevClicked ? splide.go('-1') : splide.go('+1');
    }

    const slidesWidthRecalculate = (slider) => {
        if (slider.root.classList.contains('posttype-carousel--basic')) {
            return;
        }

        const {perPage, gap } = slider.options;

        if (perPage % 2 === 0 || perPage <= 1) {
            return;
        }

        const items = slider.root.querySelectorAll('.splide__slide')
        const featured = slider.root.querySelector('.post-featured')?.closest('.splide__slide');

        const simulatePerPage = perPage + 1;
        const normalWidth = slider.root.offsetWidth - (gap * (simulatePerPage - 1));
        
        // First slide should be wider 2x than others, but still should be displayed same perPage slides
        const featuredWidthOfTwoSlides = (normalWidth / simulatePerPage) * 2 + gap;
        const singleSlide = (slider.root.offsetWidth - (gap * (simulatePerPage - 1))) / simulatePerPage;

        items.forEach(item => item.style.width = `${singleSlide}px`);
        featured.style.width = `${featuredWidthOfTwoSlides}px`;

    }

    const arrowShowHide = (slider) => {
        const container = slider.root.closest('.carousel-posttype')
        const arrowsWrapper = container.querySelector('.carousel-posttype__arrows');

        const { perPage } = slider.options;
        const { length } = slider.Components.Elements.slides;

        const tab = slider.root.closest('.tab-pane');

        if (tab && !tab.classList.contains('active')) {
            return;
        }
        
        const action = length <= perPage ? 'add' : 'remove';

        arrowsWrapper?.classList[action]('d-none');
    }

    document.addEventListener( 'DOMContentLoaded', () => {
        const carousels = document.querySelectorAll('.posttype-carousel');
        
        if (!carousels) {
            return;
        }
        
        const sliders = [];

        carousels.forEach(carousel => {
            const slider = new Splide( carousel, {
                perPage: 1,
                perMove: 1,
                gap: 10,
                autoWidth: false,
                pagination: false,
                trimSpace: false,
                arrows: false,
                type: 'slide',
                mediaQuery: 'min',
                destroy: true,
                breakpoints: {
                    992: {
                        destroy: false,
                        perPage: carousel.dataset.lg ?? 3,
                    },
                }

            });

            slider.on('mounted', () => arrowShowHide(slider));
            slider.on('ready', () => slidesWidthRecalculate(slider));
            slider.on('ready resize', () => slidesWidthRecalculate(slider));
            slider.mount();
            sliders.push(slider);
        });


        const carouselTabs = document.querySelectorAll('.nav-carousel-pills');
        const tabsSlider = triggerArrowsByTabs(carouselTabs, sliders)
        
        const arrowWrapper = document.querySelectorAll('.carousel-posttype__arrows');
        if (!arrowWrapper) {
            return;
        }

        arrowWrapper.forEach(wrapper => wrapper.addEventListener('click', (e) => arrowHandler.apply(this, [e, wrapper, sliders])))
    });

};
